import { useState } from "react";
import { toast } from "sonner";
import { login, formatError } from "@/game/api";

export function useLoginForm(onLoggedIn) {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const canSubmit = Boolean(name.trim() && password) && !loading;

  const submit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setLoading(true);
    setError("");
    try {
      const p = await login(name.trim(), password);
      setPassword("");
      onLoggedIn(p);
      toast.success(`Welcome back, ${p.name}!`);
    } catch (err) {
      setError(formatError(err, "Could not reach the arcade. Try again."));
    } finally {
      setLoading(false);
    }
  };

  return { name, setName, password, setPassword, error, loading, canSubmit, submit };
}
